<template>
  <ModalRemanejamento modal-id="modal-remanejar-servico" :servico="servico" :registro-id="servico_id"
    @remanejado="$router.go(-1)" />
</template>
<script>
import ModalRemanejamento from './ModalRemanejamento';
export default {
  components: { ModalRemanejamento },
  props: ['servico', 'servico_id', 'tecnico_id'],
};
</script>
